import React from "react";
import { useUserUsage } from "components/util/helpers/UserUsage";
import HelpMessage from "components/util/helpers/HelpMessage";
import l from "components/util/l";

const getLicenseDisplayName = {
  "BASIC": l("Básico%VG092"),
  "PRO": l("Pro%VG099"),
  "PREMIUM": l("Premium%VG100"),
  "ENTERPRISE": l("Empresarial%VG093"),
  "TEST": l("Prueba%VG101"),
  "DEMO": l("Demo%VG102"),
  "TEST_EXT": "Test-ext%VG103"
}

const UserPlanMessage = () => {

  const { userUsage } = useUserUsage();
  let renderMessages = [];
  let textColor = "text-warning";

  if(userUsage.credits.percentage == 100) {
    renderMessages.push(l("Te has quedado sin créditos%VG113"));
    textColor = "text-danger";
  }
  else if(userUsage.credits.percentage > 85) {
    renderMessages.push(l("Te estás quedando sin créditos disponibles%VG114"));
  }

  if(userUsage.storage.percentage == 100) {
    renderMessages.push(l("Te has quedado sin almacenamiento disponible%VG115"));
    textColor = "text-danger";
  }
  else if(userUsage.storage.percentage > 85) {
    renderMessages.push(l("Te estás quedando sin almacenamiento disponible%VG116"));
  }

  if(userUsage.flows.percentage == 100) {
    renderMessages.push(l("Te has quedado sin soluciones disponibles%VG117"));
    textColor = "text-danger";
  }
  else if(userUsage.flows.percentage > 85) {
    renderMessages.push(l("Te estás quedando sin soluciones disponibles%VG118"));
  }

  renderMessages = renderMessages.map(msg => `- ${msg}`);

  return <>
    Plan {getLicenseDisplayName[userUsage?.license?.category?.name]} 
    {
      renderMessages.length > 0 && (
          <HelpMessage
            message={renderMessages.join("\n")}
            forceShow={true}
          >
            <i className={`tio-warning mr-1 ${textColor} ml-1`} />
          </HelpMessage>
      )
    }
  </>

}

const UpgradePlanMessage = ({
  className = "",
  label,
}) => {
  return <>
    <div
      className={`d-flex flex-column ${className}`}
    >
      <div className="alert alert-soft-danger text-center mt-2 mb-2">
        {label}
      </div>
      <a
        href="/app/settings/plan"
        className="btn btn-success"
      >
        <i className="fas fa-arrow-up mr-2"></i>{l("Actualiza tu plan%VG105")}
      </a>
    </div>
  </>
}

export {
  UserPlanMessage,
  UpgradePlanMessage,
  getLicenseDisplayName
}